var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"profileModal",attrs:{"title":_vm.$t('PROFILE_MODAL_TITLE'),"hide-footer":"","size":"xl","no-close-on-backdrop":""}},[_c('b-tabs',[_c('profile-invoices-tab')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }